import { createContext, useContext } from "react";

type DocumentChangeType = "tierId" | "categoryId";

export interface AlertData {
  type: DocumentChangeType;
  newValue: string;
}

interface DocumentFieldsContextValue {
  setDocumentValueWithGuard: (data: AlertData) => void;
}

export const DocumentFieldsContext =
  createContext<DocumentFieldsContextValue | null>(null);

export const useDocumentFieldsContext = (): DocumentFieldsContextValue => {
  const context = useContext(DocumentFieldsContext);

  if (!context) {
    throw new Error("Document fields must be used within DocumentFieldsGuard");
  }

  return context;
};
